export default "__VITE_ASSET__1ce62c59__"